import store from "../store";

export default (to, from, next) => {
  const hasUltimatePermission = store.getters["auth/hasUltimatePermission"];
  try {
    if (!hasUltimatePermission("*"))
      return next({ path: "/" });


    if (to.meta.permission) {
      if (!hasUltimatePermission(to.meta.permission)) throw new Error();
    }

    next();
  } catch {
    console.log("[ULTIMATE]: not authorized ");
    return next({ path: "/ultimate" });
  }
};
